<template>
  <header class="subHeader">
    <div class="content-header">APPROVED</div>
    <div class="content-body">Events that have been approved and scheduled.</div>
  </header>
</template>
<script>
export default {
  name: 'subHeaderApprove',
  methods: {
    sidebarToggle (e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    }
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// SubHeaderApprove.vue?ea3a3774